import postFragment from '@orgnc/core/lib/wordpress/api/fragments/postFragment';
import { gql } from 'graphql-request';

const acfCategoryArticleListBlockFragment = gql`
  fragment AcfCategoryArticleListBlockFragment on AcfCategoryArticleListBlock {
    layout
    includeSectionDivider
    categoryPosts: posts {
      id
      ...PostFragment
    }
  }
  ${postFragment}
`;

export default acfCategoryArticleListBlockFragment;
